module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0eab6235a1e9d8ff5beb1ecd80559ff5.png";